import { BaseApiService } from '../../common/services/baseApiService';
import { API_URL } from '../../common/utils/util';
import {
  ListaMovimientos,
  MovimientoTemporal,
  ResultadoAlta,
  SelectorItem,
} from '../types/vendedores.types';

export class VendedoresService extends BaseApiService {
  /**
   * Lo que ve el selector de una tienda.
   *
   * ⚠️ Consultar como admin lee **la misma llave de caché** que la tienda desde
   * que las altas y bajas de movimientos borran por patrón (todas las variantes
   * de rol). Antes no era así y este visor habría mostrado lo que la tienda
   * *debería* ver, no lo que ve — que fue justo lo que casi hizo cerrar en falso
   * el caso del 2026-08-17.
   */
  static async getSelector(
    chain: string,
    branchOffice: number,
  ): Promise<SelectorItem[]> {
    const response = await fetch(
      `${API_URL}/branch-offices/sellers?chain=${encodeURIComponent(chain)}&branchOffice=${branchOffice}`,
      { method: 'GET', headers: this.getAuthHeaders() },
    );
    const data = await this.handleResponse<SelectorItem[] | { data: SelectorItem[] }>(
      response,
    );
    return Array.isArray(data) ? data : (data?.data ?? []);
  }

  static async listarMovimientos(): Promise<ListaMovimientos> {
    const response = await fetch(`${API_URL}/branch-offices/movimientos-temporales`, {
      method: 'GET',
      headers: this.getAuthHeaders(),
    });
    return this.handleResponse<ListaMovimientos>(response);
  }

  static async guardarMovimiento(
    chain: string,
    movimiento: MovimientoTemporal,
  ): Promise<ResultadoAlta> {
    const response = await fetch(
      `${API_URL}/branch-offices/movimientos-temporales?chain=${encodeURIComponent(chain)}`,
      {
        method: 'POST',
        headers: this.getAuthHeaders(),
        body: JSON.stringify(movimiento),
      },
    );
    return this.handleResponse<ResultadoAlta>(response);
  }

  static async quitarMovimiento(
    chain: string,
    empleado: number,
  ): Promise<{ quitado: boolean; sucursalesRefrescadas: number[] }> {
    const response = await fetch(
      `${API_URL}/branch-offices/movimientos-temporales/${empleado}?chain=${encodeURIComponent(chain)}`,
      { method: 'DELETE', headers: this.getAuthHeaders() },
    );
    return this.handleResponse<{ quitado: boolean; sucursalesRefrescadas: number[] }>(
      response,
    );
  }
}
